// index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import store from './stores/authStore';
import App from './App';
import './index.css';

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
<React.StrictMode>
    <Provider store={store}> 
      <App />
    </Provider>
  </React.StrictMode>
);